module.exports = __webpack_public_path__ + "img/160419724814650.f68e39b6.jpg";